import React from 'react';
import { motion } from 'framer-motion';

export const LevelBadge = ({ level, size = 'md' }) => {
  const sizes = {
    sm: 'w-12 h-12 text-sm',
    md: 'w-16 h-16 text-xl',
    lg: 'w-20 h-20 text-2xl',
  };

  return (
    <motion.div
      className={`hexagon-clip bg-gradient-to-br from-zinc-800 to-zinc-900 border-2 border-neon-lime flex items-center justify-center font-black font-primary ${sizes[size]}`}
      whileHover={{ scale: 1.1, rotate: 5 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      <span className="text-neon-lime" data-testid="level-badge-value">
        {level}
      </span>
    </motion.div>
  );
};
